
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/integrations",
      function () {
        return require("private-next-pages/profile/integrations/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/integrations"])
      });
    }
  